import { html, render } from "lit-html";
import { repeat } from "lit-html/directives/repeat.js";
import { translate } from "@escapio/shared/l10n/translate";

/**
 * Element to select the sorting
 *
 * @author bgr
 */
export class SortingSelector extends HTMLElement {
	constructor(options) {
		super();
		this.options = options;
	}

	connectedCallback() {
		this.render();
	}

	render() {
		render(this.template, this, { host: this });
	}

	get template() {
		return html`
			${repeat(
				this.options.values(),
				({ value }) => value,
				({ value, label }) =>
					html`<label class="form-radio"
						><input
							class="form-radio__input"
							type="radio"
							name="sorting"
							value=${value}
							.checked=${value == this.selectedValue}
							@change=${() => this.setValue(value)}
						/><span class="form-radio__label">${label}</span></label
					>`,
			)}
		`;
	}

	get mobileTemplate() {
		return html`<select
			class="sorting__select"
			aria-label="${translate("filter_score_label")}"
			@change="${({ target }) => this.setValue(target.value)}"
		>
			${repeat(
				this.options.values(),
				({ value }) => value,
				({ value, label }) =>
					html`<option
						value="${value}"
						.selected="${this.selectedValue === value}"
					>
						${label}
					</option>`,
			)}
		</select>`;
	}

	setValue() {}
}
